import apiClient from './client'
import API from "@/api/API";

export interface BuildGraphRequest {
    source_id: string
}

export interface BuildGraphResponse {
    success: boolean
    message: string
    source_id: string
    command_id?: string
}

export interface BuildStatusResponse {
    status: string;
    message?: string;
    graphrag_processing_info?: Record<string, unknown>;
}

export const graphragApi = {
    buildGraph: async (sourceId: string): Promise<BuildGraphResponse> => {
        const response = await apiClient.post<BuildGraphResponse>(API.graphrag.build, {
            source_id: sourceId,
        })
        return response.data
    },

    getBuildStatus: async (sourceId: string): Promise<BuildStatusResponse> => {
        const response = await apiClient.get<BuildStatusResponse>(API.sources.status(sourceId))
        return response.data
    },
}
